document.addEventListener("DOMContentLoaded", function () {
  const menuIcon = document.querySelector(".header__icon--menu");

  if (menuIcon) {
    menuIcon.addEventListener("click", function () {
      document.documentElement.classList.toggle("menu-open");
    });
  }
});


/*Script for Menu Opening on Hover*/ 
document.addEventListener('DOMContentLoaded', () => { 
  const dropdowns = document.querySelectorAll('.parent_li-menu details'); 

  dropdowns.forEach(details => { 
    const summary = details.querySelector('summary'); 
    if (!summary) return; 

    let timeout; 

    details.addEventListener('mouseenter', () => { 
      clearTimeout(timeout); 
      details.open = true; 
      summary.setAttribute('aria-expanded', 'true');
    }); 

    details.addEventListener('mouseleave', () => { 
      timeout = setTimeout(() => { 
        details.open = false; 
        summary.setAttribute('aria-expanded', 'false');
      }, 150); 
    }); 
  }); 
});